export default __webpack_public_path__ + "static/collectivit@2x-37c14ae937f1547d1899a4a412fe97ec.png";